module.exports = __webpack_public_path__ + "img/bandaid-blue.e1cae632.svg";